import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconInfoCircleOutline } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import styles from '../TopUpStatusAlertBox.module.css';
import messages from './Alerts.messages';

export const NotYetTopUpEligibleAlert = ({
    amountToRepayBeforeTopUp
}: {
    amountToRepayBeforeTopUp: number;
}) => {
    return (
        <TopUpStatusAlertBox
            variant="cancel"
            icon={<IconInfoCircleOutline className={styles.blueAlertBoxIcon} />}
            className={styles.blueAlertBox}
            description={
                <>
                    <strong>
                        <FormattedMessage
                            {...messages.notYetTopupEligibleAlertText}
                            values={{
                                amount: (
                                    <FormattedCurrency
                                        value={amountToRepayBeforeTopUp}
                                    />
                                )
                            }}
                        />
                    </strong>{' '}
                    <FormattedMessage
                        {...messages.notYetTopupEligibleAlertDescription}
                    />
                </>
            }
        />
    );
};
